import { cn } from "@client/utils/cn";

// Animated equalizer bars — the "now playing" cue shown on the thumbnail whose
// video is actually playing, so a live video is distinguishable from a merely
// selected-but-paused one at a glance across a strip. Purely decorative
// (aria-hidden): the playing/paused state is already conveyed by the button's
// title and aria-pressed. Motion + reduced-motion fallback live in globals.css
// (`.now-playing-bars`). Bars inherit `currentColor`.
export function NowPlayingBars({ className }: { className?: string }) {
  return (
    <span aria-hidden className={cn("now-playing-bars h-3.5", className)}>
      <span />
      <span />
      <span />
    </span>
  );
}
